module.exports = __webpack_public_path__ + "static/media/Frame-8.35acf982.svg";